// Widget Scripts
import countdown from './js/widgets/countdown.js';

// Custom Theme Scripts
import './js/localjs.js';



// Initialize Homepage Widgets if is required
$(document).ready(function () {
  countdown();
  if (globalThis.location.pathname === '/') {
    // Homepage Widgets
  }
});